<template>
  <div>
    <template v-for="(item,i) in titles">
      <title-block :key="i" :id="'bm'+item.label" v-if="item.num && activeInfo">
        <template slot="title">{{item.label}}</template>
        <div class="mt-10">
          <el-table :data="tableDatas(item.moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <template v-for="(item1, j) in tableFields(item.moduleId)">
              <el-table-column v-if="showTableColumn(item, item1)" :key="j" :label="item1.fieldName" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="whichType(scope.row[j])==='string'">{{scope.row[j]}}</span>
                  <span v-else-if="whichType(scope.row[j])==='array'" v-html="arrParse(scope.row[j], item)"></span>
                  <span v-else-if="whichType(scope.row[j])==='object'">{{scope.row[j]}}</span>
                  <span v-else-if="whichType(scope.row[j])==='img'"><img style="width:64px" :src="repliceHttps(scope.row[j])" alt="" srcset=""></span>
                  <span v-else-if="whichType(scope.row[j])==='url'">
                    <a rel="noopener noreferrer" v-if="!scope.row[j].includes(',')" :href="scope.row[j]" target="_blank">{{scope.row[j]}}</a>
                    <span v-else>
                      <a rel="noopener noreferrer" v-for="(url,i) in scope.row[j].split(',')" :key="i" :href="url" target="_blank">{{url}}</a>
                    </span>
                  </span>
                  <span v-else>{{ scope.row[j] || '--' }} </span>
                </template>
              </el-table-column>
            </template>

          </el-table>
          <pagination :pageNum="tablePage(item.moduleId)" :total="tableTotal(item.moduleId)" @currentChange="val => handleCurrentChange(val, i)" />
        </div>
      </title-block>
    </template>
  </div>
</template>

<script>
import mixin from '../mixins/enterpriseTabs'
import { fields as constFields, value as realValue, isFunc } from '@/views/clue/api/fields'

export default {
  mixins: [mixin],
  name: '',
  data() {
    return {
      titles: [
        { type: '', label: '商标信息', num: 0, moduleId: '' },
        { type: '', label: '专利信息', num: 0, moduleId: '' },
        { type: '', label: '资质证书', num: 0, moduleId: '' },
        { type: '', label: '软件著作权', num: 0, moduleId: '' },
        { type: '', label: '网站备案', num: 0, moduleId: '' },
        { type: '', label: '著作权', num: 0, moduleId: '' },
      ],
    }
  },
  computed: {
    showTableColumn() {
      return (item, item1) => {
        if (!constFields[item.moduleId]) return item1.field != 'rk'
        return constFields[item.moduleId][item1.fieldName]
      }
    }
  },
  methods: {
    arrParse(str, item) {
      const [{isNew}] = this.activeInfo.filter(v=>v.moduleId == item.moduleId)
      if (isNew) return JSON.parse(str).join(',')
      return str
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-table th > .cell {
  font-size: 12px;
  font-weight: 400;
}
/deep/ .el-table th {
  padding: 10px 0;
  line-height: 16px;
}
/deep/ .el-table .cell {
  font-size: 12px;
  font-weight: 400;
  span {
    font-size: 12px;
  }
}
</style>
